import React from 'react';
import { useLocation } from 'react-router-dom';
import PreFormValidateDni from '../../../../../common/PreFormValidateDni';
import { INFO_FORGOTTEN_PASSWORD } from '../../../../../../constants/texts';

const PreFormChangePassword = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const motiveId = params.get('motiveId');

  return (
    <PreFormValidateDni
      mobile
      motiveId={motiveId}
      issueForm={'ChangePassword'}
      info={true}
      messageInfo={INFO_FORGOTTEN_PASSWORD}
    />
  );
};

export default PreFormChangePassword;
